import { ACTION_RESET_LOADER, ACTION_SET_LOADER, DEFAULT, type LoaderState, LoaderType } from '../types/loader';

// TODO: BUGFIX - Something extremely fickle is happening here!
// By adding the action type definition of `LoaderActionTypes` the `store/index.ts` dispatch breaks in seemingly random places
export function loader(state: LoaderState = DEFAULT, action): LoaderState {
    switch (action.type) {
        case ACTION_SET_LOADER: {
            const newCounter = action.state.open ? state.counter + 1 : state.counter - 1;

            const newState: LoaderState = {
                ...{
                    open: false,
                    type: LoaderType.Default,
                },
                counter: newCounter,
                ...action.state,
            };

            return {
                ...state,
                ...newState,
            };
        }
        case ACTION_RESET_LOADER:
            return { ...DEFAULT };
        default:
            return { ...state };
    }
}
